/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/no-array-index-key */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef } from 'react';
import { MdSend } from 'react-icons/md';

import PropTypes from 'prop-types';

import {
    Box,
    Button,
    Dialog,
    IconButton,
    MenuItem,
    Select,
    TextareaAutosize,
    Tooltip,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import CustomScrollbars from '~/components/CustomScrollBar';
import LocaleMessage from '~/components/LocaleMessage';

import api from '~/services/pluginbot-api';

import { DarkDialog } from '../../../styles';
import {
    Card,
    ChatDialog,
    MainArea,
    MessagesArea,
    MessageShortcut,
    GallerySelector,
    FaceArea,
    AvatarArea,
    FaceAvatar,
    FaceShortcut,
} from './styles';

const h100 = { height: '100%' };

const useStyles = makeStyles({
    tooltip: {
        padding: '1em',
        fontSize: '0.85em',
    },
});

export default function PresentationCard({
    options,
    width,
    permission,
    user,
    robot,
    status,
    application,
    sendAction,
    renderLoading,
    smallScreen,
}) {
    const classes = useStyles();
    const robot_type = robot && robot.type ? robot.type : {};
    const r_type = robot_type.code;
    const r_status = status.status || {};
    const { robot_id, operation, language: def_language } = r_status;
    const op_user = operation && operation.user ? operation.user : null;

    const is_op_user = op_user && user && op_user.id === user.id;
    const allow_permission = permission !== 'viewer';

    const messagesEndRef = useRef(null);
    const [isLoading, setIsLoading] = useState(false);

    const [userMessages, setUserMessages] = useState([]);
    const [appSettings, setAppSettings] = useState(null);
    const [languages, setLanguages] = useState([]);

    const [currLanguage, setCurrLanguage] = useState(def_language || 'pt_BR');
    const [currMessage, setCurrMessage] = useState('');
    const [currGallery, setCurrGallery] = useState('');
    const [currFace, setCurrFace] = useState(null);
    const [defMessages, setDefMessages] = useState([]);
    const [defGalleries, setDefGalleries] = useState([]);
    const [defFaces, setDefFaces] = useState([]);
    const [showFaces, setShowFaces] = useState(false);

    async function loadAppSettings(_id) {
        await api
            .get(`applications/${_id}`)
            .then(async response => {
                const { data } = response;
                const settings = data && data.settings ? data.settings : {};
                const lang =
                    settings.language && settings.language.list
                        ? settings.language.list
                        : [];
                setLanguages(lang);
                setAppSettings(data);
            })
            .catch(() => {});
        setIsLoading(false);
    }

    async function loadGalleries() {
        if (!robot_type || !robot_type.id) {
            setDefGalleries([]);
            setCurrGallery('');
            return;
        }
        await api
            .get(`types/${robot_type.id}/defaults?album_type=faces`)
            .then(response => {
                const albums = response.data;
                setDefGalleries(albums);
                setCurrGallery(albums && albums[0] ? albums[0].id : '');
            })
            .catch(() => {
                setDefGalleries([]);
                setCurrGallery('');
            });
    }

    async function loadFaces(album_id) {
        if (!album_id) {
            setDefFaces([]);
            return;
        }
        await api
            .get(`albums/${album_id}/files`)
            .then(response => {
                const files = response.data;
                setDefFaces(files);
            })
            .catch(() => {
                setDefFaces([]);
            });
    }

    async function loadDefMessages() {
        const settings =
            appSettings && appSettings.settings ? appSettings.settings : {};
        const presentation_settings =
            settings && settings.presentation_mode
                ? settings.presentation_mode
                : {};
        const all_rtype = presentation_settings.all || {};
        const rtype_settings = presentation_settings[r_type] || all_rtype;

        if (!rtype_settings || !rtype_settings.content_id) {
            setDefMessages([]);
            return;
        }
        await api
            .get(`app_contents/${rtype_settings.content_id}`)
            .then(response => {
                const c = response.data;
                const content = c.content || {};
                const texts = content.texts || [];
                setDefMessages(texts);
            })
            .catch(() => {
                setDefMessages([]);
            });
    }

    async function saveMessage(data) {
        const body = {
            robot_id,
            application_id: application ? application.id : '',
            message: data,
        };

        await api
            .post(`/apps/presentation/message`, body)
            .then(response => {
                sendAction({
                    action: 'speak_message',
                    data: response.data,
                });
            })
            .catch(() => {});
    }

    function sendSetScreen(type, media) {
        sendAction({
            action: 'set_screen',
            data: {
                type,
                ...media,
            },
        });
    }

    function onExitClick() {
        setIsLoading(true);
        setUserMessages([]);
        setCurrMessage('');
        const exit_params = options.exit_mode || {};
        sendAction(exit_params);
    }

    const handleTabClosing = () => {
        onExitClick();
    };

    const scrollToBottom = () => {
        return messagesEndRef && messagesEndRef.current
            ? messagesEndRef.current.scrollIntoView({ behavior: 'smooth' })
            : null;
    };

    useEffect(() => {
        window.addEventListener('unload', handleTabClosing);
        return () => {
            window.removeEventListener('unload', handleTabClosing);
        };
    }, []);

    useEffect(() => {
        scrollToBottom();
    }, [userMessages]);

    useEffect(() => {
        if (application && application.id) {
            loadAppSettings(application.id);
        }
    }, [application.id]);

    useEffect(() => {
        if (r_type) {
            loadDefMessages();
        }
    }, [appSettings, r_type]);

    useEffect(() => {
        loadGalleries();
    }, [robot_type]);

    useEffect(() => {
        loadFaces(currGallery);
    }, [currGallery]);

    function sendMessage(message) {
        if (message === '') return;
        const data = {
            language: currLanguage,
            text: message,
            timestamp: new Date(),
        };

        setUserMessages([...userMessages, data]);
        saveMessage(data);
        setCurrMessage('');
    }

    function onTextEdit(event) {
        setCurrMessage(event.target.value);
    }

    function renderInUseCard() {
        return (
            <div className={`${width} mb-3`} style={h100}>
                <Box style={h100}>
                    <Card>
                        <div className="content mb-3">
                            <span className="jr-fs-md title mb-3">
                                <LocaleMessage msg="rc3.robot.data.card.presentation.title" />
                            </span>
                            <div className="info">
                                <span className="big-value">
                                    {op_user ? op_user.name : '---'}
                                </span>
                            </div>
                        </div>
                        <Button
                            fullWidth
                            className="mb-3"
                            variant="contained"
                            color="primary"
                            disabled={!allow_permission}
                            onClick={() => onExitClick()}
                        >
                            <LocaleMessage msg="rc3.robot.data.card.presentation.exit" />
                        </Button>
                    </Card>
                </Box>
            </div>
        );
    }

    function renderContentShortcut(shortcut) {
        const l_message =
            currLanguage && shortcut[currLanguage]
                ? shortcut[currLanguage]
                : null;

        const is_shortcut = !!shortcut.tag;
        return l_message ? (
            <Tooltip
                title={l_message}
                placement="right"
                arrow
                disableHoverListener={!is_shortcut}
                classes={{ tooltip: classes.tooltip }}
                key={`message_${shortcut.item_id}`}
            >
                <MessageShortcut
                    className="d-flex flex-nowrap shortcut-item mb-3"
                    bold={is_shortcut}
                    onClick={() => {
                        sendMessage(l_message);
                    }}
                >
                    <div className="bubble jambo-card">
                        <div className="message">
                            {is_shortcut ? `# ${shortcut.tag}` : l_message}
                        </div>
                    </div>
                </MessageShortcut>
            </Tooltip>
        ) : null;
    }

    function renderMessage(message) {
        const timestamp = new Date(message.timestamp);

        return (
            <div
                className="d-flex flex-nowrap chat-item"
                key={`message_${timestamp.getUTCMilliseconds()}`}
            >
                <div className="bubble jambo-card px-3">
                    <div className="message px-2 py-1">{message.text}</div>
                    <div className="time text-muted text-right mt-2">
                        {timestamp.toLocaleTimeString(undefined)}
                    </div>
                </div>
            </div>
        );
    }

    function renderFaceItem(face) {
        return (
            <div className="col-12 my-3 px-0" key={face.id}>
                <FaceShortcut
                    className="half-img-title"
                    src={face.url}
                    alt={face.name}
                    style={{
                        width: '100%',
                    }}
                    onClick={() => {
                        setShowFaces(false);
                        setCurrFace(face);
                        sendSetScreen('face', {
                            face: face.name,
                            media: face.name,
                        });
                    }}
                />
            </div>
        );
    }

    function renderFaces() {
        let face = currFace;
        if (!face && r_status && r_status.screen) {
            const curr_screen = r_status.screen || {};
            if (curr_screen.type === 'face' && curr_screen.media) {
                face = defFaces.find(f => {
                    return f.name === curr_screen.media;
                });
            }
        }

        const avatar = face ? (
            <div className={`${smallScreen ? 'px-1' : 'px-2'}`}>
                <AvatarArea
                    className={`${smallScreen ? 'p-2' : 'pl-2 py-5'}`}
                    smallScreen={smallScreen}
                >
                    <FaceAvatar
                        src={face.url}
                        alt={face.name}
                        onClick={() => {
                            setShowFaces(true);
                        }}
                    />
                </AvatarArea>
            </div>
        ) : null;

        return (
            <FaceArea
                smallScreen={smallScreen}
                showFaces={showFaces}
                className={`col-md-${smallScreen ? '4' : '2'} px-0 mb-5`}
            >
                {showFaces ? (
                    <CustomScrollbars className="scrollbar">
                        {defGalleries && defGalleries.length > 1 ? (
                            <GallerySelector className="px-2">
                                <Select
                                    className="my-3"
                                    fullWidth
                                    value={currGallery}
                                    onChange={event =>
                                        setCurrGallery(event.target.value)
                                    }
                                    style={{
                                        color: '#fff',
                                        textAlign: 'center',
                                    }}
                                >
                                    {defGalleries.map(g => {
                                        return (
                                            <MenuItem
                                                key={`album_${g.id}`}
                                                value={g.id}
                                            >
                                                {g.name}
                                            </MenuItem>
                                        );
                                    })}
                                </Select>
                            </GallerySelector>
                        ) : null}
                        <div className="chat-faces py-3 px-2">
                            {defFaces.map(f => renderFaceItem(f))}
                        </div>
                    </CustomScrollbars>
                ) : (
                    avatar
                )}
            </FaceArea>
        );
    }

    function renderDialogComponents() {
        const showShortcuts = defMessages.length > 0;

        return (
            <ChatDialog className="chat-box">
                <div className="chat-box-main">
                    <div className="chat-header">
                        <div className="chat-header-info">
                            <div className="chat-contact-name">
                                <LocaleMessage msg="rc3.robot.data.card.presentation.title" />
                            </div>
                            <Button
                                size="small"
                                color="primary"
                                variant="contained"
                                onClick={() => onExitClick()}
                            >
                                <LocaleMessage msg="rc3.robot.data.card.presentation.exit" />
                            </Button>
                        </div>
                    </div>

                    <div className="chat-main mx-0 px-0">
                        <MainArea
                            smallScreen={smallScreen}
                            className={`col-md-${
                                showShortcuts ? '9' : '12'
                            } col-7 ${smallScreen ? 'px-0' : ''}`}
                        >
                            {renderFaces()}

                            <MessagesArea
                                className={`col-md-${
                                    smallScreen ? '12' : '10'
                                } px-0`}
                            >
                                <CustomScrollbars className="chat-list-scroll scrollbar">
                                    <div className="chat-main-content">
                                        {userMessages.map(m =>
                                            renderMessage(m)
                                        )}
                                    </div>
                                    <div ref={messagesEndRef} />
                                </CustomScrollbars>
                            </MessagesArea>
                        </MainArea>

                        {showShortcuts ? (
                            <div className="chat-side col-md-3 col-5 px-0">
                                <CustomScrollbars className="scrollbar">
                                    <div className="chat-side-title">
                                        <LocaleMessage msg="rc3.robot.data.card.presentation.shortcuts" />
                                    </div>
                                    <div className="chat-side-content">
                                        {defMessages.map((m, i) =>
                                            renderContentShortcut(m, i)
                                        )}
                                    </div>
                                </CustomScrollbars>
                            </div>
                        ) : null}
                    </div>

                    <div className="chat-footer">
                        <div
                            className="d-flex flex-row align-items-center"
                            style={{ height: '100%' }}
                        >
                            <div className="chat-lang">
                                <Select
                                    value={currLanguage}
                                    onChange={event =>
                                        setCurrLanguage(event.target.value)
                                    }
                                >
                                    {languages.map(l => {
                                        const l_split = l.split('_');
                                        const l_country = l_split[1]
                                            ? l_split[1].toLowerCase()
                                            : 'br';
                                        return (
                                            <MenuItem
                                                key={`lang_${l}`}
                                                value={l}
                                            >
                                                <IconButton className="icon-btn">
                                                    <i
                                                        className={`flag flag-24 flag-${l_country}`}
                                                    />
                                                </IconButton>
                                            </MenuItem>
                                        );
                                    })}
                                </Select>
                            </div>
                            <div className="col form-group m-0">
                                <TextareaAutosize
                                    className="border-0 form-control chat-textarea"
                                    value={currMessage}
                                    color="primary"
                                    onKeyPress={event => {
                                        if (event.key === 'Enter') {
                                            event.preventDefault();
                                            event.stopPropagation();
                                            sendMessage(currMessage);
                                        }
                                    }}
                                    onChange={event => {
                                        onTextEdit(event);
                                    }}
                                />
                            </div>
                            <div className="chat-sent">
                                <IconButton
                                    onClick={() => sendMessage(currMessage)}
                                >
                                    <MdSend color="primary" />
                                </IconButton>
                            </div>
                        </div>
                    </div>
                </div>
            </ChatDialog>
        );
    }

    function renderInputDialog() {
        return (
            <Dialog open onClose={() => onExitClick()} fullWidth maxWidth="md">
                <DarkDialog>
                    {!isLoading ? renderDialogComponents() : renderLoading()}
                </DarkDialog>
            </Dialog>
        );
    }

    function renderContent() {
        return is_op_user ? renderInputDialog() : renderInUseCard();
    }

    return operation && operation.mode === 'presentation'
        ? renderContent()
        : null;
}

PresentationCard.propTypes = {
    width: PropTypes.string,
    permission: PropTypes.string,
    options: PropTypes.object,
    user: PropTypes.object,
    status: PropTypes.object,
    robot: PropTypes.object,
    application: PropTypes.object,
    sendAction: PropTypes.func.isRequired,
    renderLoading: PropTypes.func.isRequired,
    smallScreen: PropTypes.bool,
};

PresentationCard.defaultProps = {
    width: 'col-12',
    permission: '',
    user: {},
    robot: {},
    status: {},
    application: {},
    options: {},
    smallScreen: false,
};
